import { Box, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

export const ConditionsTooltipContent = () => {
  const { t } = useTranslation();

  return (
    <Stack gap="xs" p="sm">
      <Box>
        <Text
          fz="sm"
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.2",
          }}
        >
          <Text fw="bold" fz="sm" component="span">
            {t("car.conditions.superb")}
          </Text>
          : {t("tooltips.superb_short")}
        </Text>
      </Box>
      <Box>
        <Text
          fz="sm"
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.2",
          }}
        >
          <Text fw="bold" fz="sm" component="span">
            {t("car.conditions.excellent")}
          </Text>
          : {t("tooltips.excellent_short")}
        </Text>
      </Box>
      <Box>
        <Text
          fz="sm"
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.2",
          }}
        >
          <Text fw="bold" fz="sm" component="span">
            {t("car.conditions.good")}
          </Text>
          : {t("tooltips.good_short")}
        </Text>
      </Box>
      <Box>
        <Text
          fz="sm"
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.2",
          }}
        >
          <Text fw="bold" fz="sm" component="span">
            {t("car.conditions.fair")}
          </Text>
          : {t("tooltips.fair_short")}
        </Text>
      </Box>
    </Stack>
  );
};
